const state = {
  apiUrl: 'https://admin.mcs.local/api/',
  logoUrlLight:
    'https://res.cloudinary.com/mycreativeshop/image/upload/f_auto/public/mcs-logo-light',
  logoUrlDark: 'https://res.cloudinary.com/mycreativeshop/image/upload/f_auto/public/mcs-logo-dark',
  numDialogsOpen: 0,
  routeKey: 'a'
};

const getters = {
  anyDialogsOpen(state) {
    return state.numDialogsOpen > 0;
  }
};

const actions = {};

const mutations = {
  INCREMENT_DIALOGS_OPEN(state) {
    state.numDialogsOpen++;
  },

  DECREMENT_DIALOGS_OPEN(state) {
    state.numDialogsOpen--;
  },

  REFRESH_CURRENT_ROUTE(state) {
    state.routeKey = state.routeKey === 'a' ? 'b' : 'a';
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
